<template>
  <div class="InventoryDashboard">
    <div>
      <el-row :gutter="10" class="mt-2">
        <el-col :xs="24" :sm="8" :md="4" :lg="4" :xl="4">
          <div class="store-inventory-card">
            <p class="inventory-card-label">Total Inventory</p>
            <p class="inventory-card-value">{{ summary.total_inventory }}</p>
          </div>
        </el-col>
        <el-col :xs="24" :sm="8" :md="4" :lg="4" :xl="4">
          <div class="store-inventory-card">
            <p class="inventory-card-label">Store</p>
            <p class="inventory-card-value">{{ summary.store_total }}</p>
          </div>
        </el-col>
        <el-col :xs="24" :sm="8" :md="4" :lg="4" :xl="4">
          <div class="store-inventory-card">
            <p class="inventory-card-label">Warehouse</p>
            <p class="inventory-card-value">{{ summary.warehouses_total }}</p>
          </div>
        </el-col>
        <el-col :xs="24" :sm="12" :md="4" :lg="4" :xl="4">
          <div class="store-inventory-card">
            <p class="inventory-card-label">Usage</p>
            <p class="inventory-card-value">{{ summary.total_usage }}</p>
          </div>
        </el-col>
        <el-col :xs="24" :sm="12" :lg="4" :xl="4" :md="4">
          <div class="store-inventory-card">
            <p class="inventory-card-label">Coverage Days</p>
            <p class="inventory-card-value">0 Days</p>
          </div>
        </el-col>
        <el-col :xs="24" :sm="12" :lg="4" :xl="4" :md="4">
          <div class="store-inventory-card">
            <p class="inventory-card-label">Sales Loss</p>
            <p class="inventory-card-value">{{ summary.loss_percent }}%</p>
            <p class="text-sm">{{ summary.loss }}</p>
          </div>
        </el-col>
      </el-row>
    </div>

    <el-card class="box-card">
      <div style="padding: 15px">
        <div class="flex">
          <div class="input-box box-220">
            <p class="input-label">Quick Reports</p>
            <el-select
              v-model="params.quickreport"
              style="width: 100%"
              placeholder="Select"
              @change="changedQuickReport(params.quickreport)"
            >
              <el-option
                v-for="(quick_report, index) in allQuickReports"
                :key="index"
                :value="quick_report.id"
                :label="quick_report.name"
                :disabled="
                  (quick_report.id == 'wow' && params.view != 'usage') ||
                  (quick_report.id == 'mom' && params.view != 'usage') ||
                  index != 0
                "
              >
                {{ quick_report.name }}
              </el-option>
            </el-select>
            <!-- :disabled="isContributionView &&( quick_report.id == 'day' || quick_report.id == 'week' || quick_report.id == 'month' || quick_report.id == 'wow' || quick_report.id == 'mom')" -->
          </div>
          <div class="input-box box-220">
            <p class="input-label">Report Type</p>
            <el-select v-model="view" style="width: 100%" placeholder="Select">
              <el-option
                v-for="(view, index) in viewList"
                :key="index"
                :value="view.id"
                :label="view.name"
                :disabled="
                  (params.quickreport == 'wow' && view.id == 'variance') ||
                  (params.quickreport == 'mom' && view.id == 'variance')
                "
              >
                {{ view.name }}
              </el-option>
            </el-select>
          </div>
          <div class="input-box box-220">
            <p class="input-label">Date From</p>
            <el-date-picker
              v-model="start_date"
              type="date"
              placeholder="Select Date"
              style="width: 100%"
              :disabled="params.quickreport != 'sale'"
              :picker-options="datePickerOptions"
            />
          </div>
          <div class="input-box box-220">
            <p class="input-label">Date To</p>
            <el-date-picker
              v-model="end_date"
              type="date"
              placeholder="Select Date"
              style="width: 100%"
              :disabled="params.quickreport != 'sale'"
              :picker-options="datePickerOptions"
            />
          </div>
          <div>
            <div>
              <el-button
                class="toggle-btn"
                style="min-width: 110px; margin-top: 15px; height: 40px"
                @click="goInventory()"
                >Go</el-button
              >
            </div>
          </div>
        </div>
      </div>
      <div style="padding: 15px">
        <div class="flex">
          <div class="input-box box-300">
            <p class="input-label">Location</p>
            <base-locations-dropdown @update="dropDownUpdate" />
          </div>
          <div class="input-box box-250">
            <base-categories-dropdown
              @categoryUpdate="categoryDropdownUpdate"
            />
          </div>
          <div class="input-box box-220">
            <p class="input-label">Item Type</p>
            <el-select
              v-model="params.article_type"
              placeholder="Select"
              clearable
            >
              <el-option value="product" label="SKU"> SKU </el-option>
              <el-option value="raw_material" label="Raw Material">
                Raw Material
              </el-option>
              <el-option value="intermediate" label="Intermediate">
                Intermediate
              </el-option>
            </el-select>
          </div>
          <div class="input-box box-220">
            <p class="input-label">Search</p>
            <el-input
              v-model="search"
              placeholder="search"
              @change="searchInventory()"
            >
            </el-input>
          </div>
        </div>
      </div>
      <!-- <div class="mdms__parent">
				<base-locations-dropdown class="mdms" @update="dropDownUpdate" />
				<base-categories-dropdown
					class="mdms"
					@categoryUpdate="categoryDropdownUpdate"
				/>
				<div style="margin: 15px;">
					<p class="font-bold label">
						View
					</p>
					<el-select
						v-model="params.article_type"
						style="width: 250px"
						placeholder="Select"
						clearable
					>
						<el-option value="product" label="SKU">
							SKU
						</el-option>
						<el-option value="raw_material" label="Raw Material">
							Raw Material
						</el-option>
					</el-select>
				</div>
				<div style="width: 300px;">
					<el-input
						v-model="search"
						size="medium"
						placeholder="search"
						style="width: 300px;"
						@change="searchInventory()"
					>
					</el-input>
				</div>
			</div> -->
    </el-card>

    <div
      v-if="params.view != 'stockout'"
      v-loading="isTableDataLoading"
      class="inventory-table"
    >
      <div>
        <span
          :class="[
            breadCrumbs.length > 0
              ? 'cursor-pointer text-black capitalize text-sm hover:text-orange-dark'
              : 'text-grey-dark text-sm capitalize',
          ]"
          @click="defaultBreadcurmbClicked()"
          >Inventory Dashboard
          <i
            class="el-icon-arrow-right"
            style="font-size: 15px; vertical-align: text-bottom"
          ></i>
        </span>
        <span v-for="(bread_curmb, index) in breadCrumbs" :key="index">
          <span v-for="(key, value, obj_index) in bread_curmb" :key="obj_index">
            <span
              :class="[
                value == active_breadCrumbs
                  ? 'cursor-pointer text-grey-dark text-sm capitalize'
                  : 'cursor-pointer text-black capitalize text-sm hover:text-orange-dark',
              ]"
              @click="breadCurmbClicked(value, key)"
            >
              {{ value }}
            </span>
            <span v-if="index != breadCrumbs.length - 1">
              <i
                class="el-icon-arrow-right"
                style="font-size: 15px; vertical-align: text-bottom"
              ></i>
              &nbsp;
            </span>
          </span>
        </span>
      </div>

      <div v-if="inventoryList.length" style="overflow-x: auto">
        <table>
          <thead class="tableHeader">
            <tr>
              <th
                v-for="(mainHeading, index) in tableData.mainHeadings"
                :key="index"
                class="main-heading"
                :colspan="mainHeading.colspan"
              >
                <div
                  :class="{
                    'mainHeadings-border-bottom':
                      mainHeading.mainHeadingBorderBottom,
                  }"
                >
                  {{ mainHeading.value }}
                </div>
              </th>
            </tr>
            <tr style="border-top: 1px solid #ddd">
              <th
                v-for="(subHeading, index) in tableData.subHeadings"
                :key="index"
                class="sub-heading"
              >
                {{ subHeading.value }}
              </th>
            </tr>
            <!-- <tr>
							<th colspan="5"></th>
							<th colspan="2">Pipeline Stock</th>
							<th colspan="1">Delta</th>
							<th colspan="2"></th>
						</tr>
						<tr>
							<th>Item Name</th>
							<th>Value</th>
							<th>Qty</th>
							<th>umo</th>
							<th>Coverage Days</th>
							<th>Date</th>
							<th>Qty</th>
							<th>Qty</th>
							<th>Updated Coverage</th>
							<th>Usage </th>
						</tr> -->
          </thead>
          <tbody
            v-if="
              params.quickreport != 'wow' &&
              params.quickreport != 'mom' &&
              params.view == 'usage'
            "
          >
            <tr v-for="(item, index) in inventoryList" :key="index">
              <td class="head">
                <!-- <span @click="updateData(item.type, item.id, item)">{{
									item.name
								}}</span> -->
                <el-popover placement="right" width="480" trigger="click">
                  <el-table :data="popupData">
                    <el-table-column
                      width="130"
                      property="code"
                      label="Name"
                    ></el-table-column>
                    <el-table-column
                      width="100"
                      property="coverage_days"
                      label="Coverage days"
                    ></el-table-column>
                    <el-table-column
                      width="100"
                      property="quantity"
                      label="Qty"
                    ></el-table-column>
                    <el-table-column
                      width="120"
                      property="expiry_date"
                      label="EXPIRY"
                    ></el-table-column>
                  </el-table>
                  <div style="text-align: right">
                    <el-pagination
                      background
                      :current-page.sync="popupPageInfo.currentPage"
                      :page-sizes="[5, 10, 15]"
                      :page-size.sync="popupPageInfo.pageSize"
                      layout="sizes, prev, pager, next"
                      :total="popupPageInfo.count"
                      @size-change="handlePopupPageInfoChange"
                      @current-change="handlePopupPageInfoChange"
                    />
                  </div>
                  <span slot="reference" @click="showTablePopup(item.id)">{{
                    item.name
                  }}</span>
                </el-popover>
              </td>
              <td v-if="params.start_date != today || params.end_date != today">
                {{ item.date }}
              </td>
              <td>{{ item.stock_value_sum }}</td>
              <td>{{ item.stock_units_sum }}</td>
              <td v-if="params.start_date != today || params.end_date != today">
                {{ item.excess_qty }}
              </td>
              <td>{{ item.umo }}</td>
              <td v-if="params.start_date == today && params.end_date == today">
                {{ item.cov_days }}
              </td>
              <!-- <td v-if="params.start_date == params.end_date">
								{{ item.re_date }}
							</td> -->
              <td v-if="params.start_date == today && params.end_date == today">
                {{ item.pipeline_quantity }}
              </td>
              <td v-if="params.start_date == today && params.end_date == today">
                {{ item.delta_qty }}
              </td>
              <td v-if="params.start_date == today && params.end_date == today">
                {{ item.up_cov_days }}
              </td>
              <td>{{ item.usage_sum.toFixed(2) }}</td>
            </tr>
          </tbody>
          <tbody
            v-if="
              params.quickreport == 'wow' ||
              (params.quickreport == 'mom' && params.view == 'usage')
            "
          >
            <tr v-for="(item, index) in inventoryList" :key="index">
              <!-- <td class="head"><span @click="updateData(item.type, item.id, item)">{{item.name}}</span></td> -->
              <td
                v-for="(col, colIndex) in tableData.subHeadings"
                :key="colIndex"
              >
                <div v-if="col.value == ''" class="head">
                  <!-- <span @click="updateData(item.type, item.id, item)">{{
										item.name
									}}</span> -->
                  <el-popover placement="right" width="480" trigger="click">
                    <el-table :data="popupData">
                      <el-table-column
                        width="130"
                        property="code"
                        label="Name"
                      ></el-table-column>
                      <el-table-column
                        width="100"
                        property="coverage_days"
                        label="Coverage days"
                      ></el-table-column>
                      <el-table-column
                        width="100"
                        property="quantity"
                        label="Qty"
                      ></el-table-column>
                      <el-table-column
                        width="120"
                        property="expiry_date"
                        label="EXPIRY"
                      ></el-table-column>
                    </el-table>
                    <div style="text-align: right">
                      <el-pagination
                        background
                        :current-page.sync="popupPageInfo.currentPage"
                        :page-sizes="[5, 10, 15]"
                        :page-size.sync="popupPageInfo.pageSize"
                        layout="sizes, prev, pager, next"
                        :total="popupPageInfo.count"
                        @size-change="handlePopupPageInfoChange"
                        @current-change="handlePopupPageInfoChange"
                      />
                    </div>
                    <span slot="reference" @click="showTablePopup(item.id)">{{
                      item.name
                    }}</span>
                  </el-popover>
                </div>
                <div
                  v-if="col.meta == item.date && col.value == 'Stock in Value'"
                >
                  {{ item.stock_value_sum }}
                </div>
                <div
                  v-if="col.meta == item.date && col.value == 'Stock in Units'"
                >
                  {{ item.stock_units_sum }}
                </div>
                <div v-if="col.meta == item.date && col.value == 'Usage'">
                  {{ item.usage_sum.toFixed(2) }}
                </div>
                <div v-if="col.meta == item.date && col.value == '% Usage'">
                  {{ item.usage_per }}
                </div>
              </td>
              <!-- <td>{{item.stock_value_sum}}</td>
							<td>{{ item.stock_units_sum }}</td>
							<td>{{item.usage_sum}}</td>
							<td>{{item.usage_per}}</td> -->
            </tr>
          </tbody>
          <tbody v-if="params.view == 'variance'">
            <tr v-for="(item, index) in inventoryList" :key="index">
              <td class="head">
                <!-- <span @click="updateData(item.type, item.id, item)">{{
									item.name
								}}</span> -->
                <el-popover placement="right" width="480" trigger="click">
                  <el-table :data="popupData">
                    <el-table-column
                      width="130"
                      property="code"
                      label="Name"
                    ></el-table-column>
                    <el-table-column
                      width="100"
                      property="coverage_days"
                      label="Coverage days"
                    ></el-table-column>
                    <el-table-column
                      width="100"
                      property="quantity"
                      label="Qty"
                    ></el-table-column>
                    <el-table-column
                      width="120"
                      property="expiry_date"
                      label="EXPIRY"
                    ></el-table-column>
                  </el-table>
                  <div style="text-align: right">
                    <el-pagination
                      background
                      :current-page.sync="popupPageInfo.currentPage"
                      :page-sizes="[5, 10, 15]"
                      :page-size.sync="popupPageInfo.pageSize"
                      layout="sizes, prev, pager, next"
                      :total="popupPageInfo.count"
                      @size-change="handlePopupPageInfoChange"
                      @current-change="handlePopupPageInfoChange"
                    />
                  </div>
                  <span slot="reference" @click="showTablePopup(item.id)">{{
                    item.name
                  }}</span>
                </el-popover>
              </td>
              <!-- <td v-for="(col,colIndex) in tableData.subHeadings" :key="colIndex">
								<div v-if="col.value == ''" class="head">
									<span @click="updateData(item.type, item.id, item)">{{item.name}}</span>
								</div>
								<div v-if="col.meta == item.date && col.value == 'Count Date'">
									{{ item.re_date }}
								</div>
								<div v-if="col.meta == item.date && col.value == 'System Stock(uint)'">
									{{ item.stock_units_sum }}
								</div>
								<div v-if="col.meta == item.date && col.value == 'Actual Stock'">
									{{ item.usage_sum }}
								</div>
								<div v-if="col.meta == item.date && col.value == 'Variance'">
									{{ item.usage_sum }}
								</div>
								<div v-if="col.meta == item.date && col.value == '% Variance'">
									{{ item.usage_per }}
								</div>
							</td> -->
              <!-- <td>{{item.stock_value_sum}}</td> -->
              <td>{{ item.re_date }}</td>
              <td>{{ item.stock_units_sum }}</td>
              <!-- <td>{{ item.umo }}</td> -->
              <!-- <td></td> -->
              <td>{{ item.usage_sum }}</td>
              <td>{{ item.delta_qty }}</td>
              <!-- <td></td> -->
              <td>{{ item.pipeline_quantity }}</td>
              <!-- </td> -->
              <!-- <td>{{item.stock_value_sum}}</td>
							<td>{{ item.stock_units_sum }}</td>
							<td>{{item.usage_sum}}</td>
							<td>{{item.usage_per}}</td> -->
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else>
        <h3 class="text-center">No Data Found</h3>
      </div>
      <div class="text-right">
        <div v-if="inventoryList.length" class="pagination p-4 pt-0 text-right">
          <el-pagination
            background
            :current-page.sync="pageInfo.currentPage"
            :page-sizes="[5, 10, 15]"
            :page-size.sync="pageInfo.pageSize"
            layout="sizes, prev, pager, next"
            :total="pageInfo.count"
            @size-change="handlePageInfoChange"
            @current-change="handlePageInfoChange"
          />
        </div>
      </div>
    </div>
    <div class="mt-2">
      <el-card class="box-card">
        <InventoryDashboardGraph></InventoryDashboardGraph>
      </el-card>
    </div>
    <div
      v-if="params.view == 'stockout'"
      v-loading="isTableDataLoading"
      class="inventory-table"
    >
      <div
        v-if="inventoryList.length && params.view == 'stockout'"
        style="overflow-x: auto"
      >
        <table>
          <thead class="tableHeader">
            <tr style="border-top: 1px solid #ddd">
              <th class="sub-heading">Item Name</th>
              <th class="sub-heading">Forecast</th>
              <th class="sub-heading">Opening Stock</th>
              <th class="sub-heading">quantity Sold</th>
              <th class="sub-heading">Amount</th>
              <th class="sub-heading">Unmet Demand</th>
              <th class="sub-heading">Demand Value</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in inventoryList" :key="index">
              <td class="head">
                <span @click="updateData(item.type, item.id, item)">{{
                  item.name
                }}</span>
              </td>
              <td>{{ item.forecast }}</td>
              <td>{{ item.opening_stock }}</td>
              <td>{{ item.sale_qty }}</td>
              <td>{{ item.sale_value }}</td>
              <td>{{ item.unmet_quantity }}</td>
              <td>{{ item.unmet_value }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else-if="params.view == 'stockout'">
        <h3 class="text-center">No Data Found</h3>
      </div>
      <div class="text-right">
        <div v-if="inventoryList.length" class="pagination p-4 pt-0 text-right">
          <el-pagination
            background
            :current-page.sync="pageInfo.currentPage"
            :page-sizes="[5, 10, 15]"
            :page-size.sync="pageInfo.pageSize"
            layout="sizes, prev, pager, next"
            :total="pageInfo.count"
            @size-change="handlePageInfoSizeChange"
            @current-change="handlePageInfoChange"
          />
        </div>
      </div>
    </div>
    <el-dialog
      title="Table"
      :visible.sync="popupTable"
      width="50%"
      :before-close="handleClose"
    >
      <div>
        <table class="popupTable">
          <thead>
            <tr>
              <th>Name</th>
              <th>Stock</th>
              <th>Qty</th>
              <th>Expiry</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in 3" :key="index">
              <td>P1</td>
              <td>100</td>
              <td>3.5</td>
              <td>9th</td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- <span slot="footer" class="dialog-footer">
				<el-button @click="popupTable = false">Cancel</el-button>
				<el-button type="primary" @click="popupTable = false"
					>Confirm</el-button
				>
			</span> -->
    </el-dialog>
  </div>
</template>

<script>
import BaseLocationsDropdown from "../../../baseLocationsDD/BaseLocationsDD.vue";
import BaseCategoriesDropdown from "../../../baseCategoriesDD/BaseCategoriesDD.vue";
import InventoryDashboardTab from "../inventoryDashboard/inventoryDasboardTab/InventoryDashboardTab.vue";
import InventoryDashboardGraph from "../inventoryDashboard/InventoryDashboardGraph";
// import WoowGraph from "../../appWoowGraph/appWoowGraph.vue";
import CommonService from "../../../../services/commonService";
import InventoryService from "../../../../services/inventoryService";
import { EventBus } from "../../../../eventBus";
import moment from "moment";
export default {
  name: "InventoryDashboard",
  components: {
    BaseLocationsDropdown,
    BaseCategoriesDropdown,
    InventoryDashboardTab,
    InventoryDashboardGraph,
    // WoowGraph
  },
  data() {
    return {
      today: moment(new Date()).format("YYYY-MM-DD"),
      popupData: [],
      article_id: "",
      popupTable: false,
      isTableDataLoading: false,
      selectedType: "",
      selectedId: "",
      summary: {},
      locationdId: [],
      breadCrumbs: [],
      active_breadCrumbs: "",
      inventoryList: [],
      pageInfo: {
        currentPage: 1,
        count: 0,
        pageSize: 10,
      },
      popupPageInfo: {
        currentPage: 1,
        count: 0,
        pageSize: 10,
      },
      start_date: "",
      end_date: "",
      params: {
        quickreport: "sale",
        view: "usage",
        start_date: "",
        end_date: "",
        basics: "product",
        article_type: null,
        filters: {
          outlets: [],
          subcategories: [],
          countries: [],
          regions: [],
          subregions: [],
        },
      },
      tablePageCount: "",

      search: "",
      view: "usage",
      viewList: [
        {
          name: "Usage",
          id: "usage",
        },
        {
          name: "Variance",
          id: "variance",
        },
        {
          name: "Stockout",
          id: "stockout",
        },
        // {
        // 	name: 'Inventory',
        // 	id: 'inventory'
        // },
      ],
      allQuickReports: [
        {
          name: "Inventory",
          id: "sale",
          isDisabled: false,
        },
        {
          name: "Week To Date",
          id: "wtd",
          isDisabled: false,
        },
        {
          name: "Month To Date",
          id: "mtd",
          isDisabled: false,
        },
        {
          name: "Quarter To Date",
          id: "qtd",
          isDisabled: false,
        },
        {
          name: "Year To Date",
          id: "ytd",
          isDisabled: false,
        },
        // {
        // 	name: "Week On Week",
        // 	id: "wow",
        // 	isDisabled: false
        // },
        // {
        // 	name: "Month On Month",
        // 	id: "mom",
        // 	isDisabled: false
        // }
      ],
      reportType: [
        {
          name: "Last Count",
          id: "week",
          isDisabled: false,
        },
        {
          name: "YTD",
          id: "week",
          isDisabled: false,
        },
        {
          name: "WTD",
          id: "month",
          isDisabled: false,
        },
        {
          name: "WOW",
          id: "wtd",
          isDisabled: false,
        },
        {
          name: "MOM",
          id: "mtd",
          isDisabled: false,
        },
      ],
      location: "",
      outlets: {},
      reportTypeValue: "",
      datePickerOptions: {
        disabledDate: this.disabledDueDate,
      },
      tableData: {
        mainHeadings: [],
        subHeadings: [],
      },
    };
  },
  mounted() {
    this.$emit("resetPageInfoEvent", {
      pageInfo: {
        currentPage: 1,
        pageSize: 10,
      },
    });
  },

  created() {
    const today = moment(new Date()).format("YYYY-MM-DD");
    const yesterday = new Date(today);

    yesterday.setDate(yesterday.getDate() - 1);

    this.params.end_date = moment(today).format("YYYY-MM-DD");
    this.params.start_date = moment(today).format("YYYY-MM-DD");
    this.end_date = moment(today).format("YYYY-MM-DD");
    this.start_date = moment(today).format("YYYY-MM-DD");

    this.getOutlets({ get_all: true });
    this.getDepartnemtList();
    this.getSummaryData();
  },

  methods: {
    goInventory() {
      this.params.start_date = moment(this.start_date).format("YYYY-MM-DD");
      this.params.end_date = moment(this.end_date).format("YYYY-MM-DD");
      this.params.view = this.view;
      this.resetBreadCurmb();
      this.handleResetPageInfoEvent();
      this.changedData(this.params);
    },
    handleClose() {
      this.popupTable = false;
    },
    getOutlets(args) {
      CommonService.getOutlets(args).then((response) => {
        if (response.status == 200) {
          this.outlets = JSON.parse(response.data);
        }
      });
    },
    searchInventory() {
      if (this.search != "") {
        this.params.view = this.view;
        this.params.search = this.search;
        // this.changedData(this.params, this.selectedType);
      } else {
        this.params.view = this.view;
        this.params.search = "";
        // this.changedData(this.params, this.selectedType);
      }
    },
    // get departments initially to show on table
    getDepartnemtList() {
      this.isTableDataLoading = true; //enabled loader
      CommonService.getDepartmentList(this.pageInfo)
        .then((response) => {
          let res = JSON.parse(response.data);
          if (res.results.length) {
            this.selectedType = "new";

            this.fillHeadersForTable(); //fill table headers according to report type

            // this.inventoryList = res.results;
            this.isTableDataLoading = false; //disalbed loader
          } else {
            this.isTableDataLoading = false; //disalbed loader
          }
          this.changedData(this.params, this.selectedType);
        })
        .catch(
          function (error) {
            console.log(error);
            this.isTableDataLoading = false; //disalbed loader
          }.bind(this)
        );
    },

    //api to display summary at top of the page
    getSummaryData() {
      InventoryService.inventorySummary(this.params).then((response) => {
        this.summary = JSON.parse(response.data);
      });
    },

    fillHeadersForTable(response) {
      this.mainHeadings = [];
      this.subHeadings = [];
      let mainHeadings = [];
      let subHeadings = [];

      // console.log("fillHeadersForTable", this.params.quickreport);
      // console.log("response", response);

      if (
        this.params.quickreport != "mom" &&
        this.params.quickreport != "wow" &&
        this.params.view == "usage" &&
        this.params.start_date == this.today &&
        this.params.end_date == this.today
      ) {
        mainHeadings = [
          { value: "", colspan: 5, mainHeadingBorderBottom: false },
          {
            value: "Pipeline Stock",
            colspan: 1,
            mainHeadingBorderBottom: true,
          },
          { value: "Updated", colspan: 2, mainHeadingBorderBottom: true },
          { value: "", colspan: 1, mainHeadingBorderBottom: false },
        ];

        subHeadings = [
          { value: "Item Name", colspan: 1, subHeadingBorderBottom: true },
          { value: "Value", colspan: 1, subHeadingBorderBottom: true },
          { value: "Qty", colspan: 1, subHeadingBorderBottom: true },
          { value: "UOM", colspan: 1, subHeadingBorderBottom: true },
          { value: "Coverage Days", colspan: 1, subHeadingBorderBottom: true },
          // { value: "Date", colspan: 1, subHeadingBorderBottom: true },
          { value: "Qty", colspan: 1, subHeadingBorderBottom: true },
          { value: "Qty", colspan: 1, subHeadingBorderBottom: true },
          {
            value: "Updated Coverage",
            colspan: 1,
            subHeadingBorderBottom: true,
          },
          { value: "Usage", colspan: 1, subHeadingBorderBottom: true },
        ];
      } else if (
        this.params.quickreport != "mom" &&
        this.params.quickreport != "wow" &&
        this.params.view == "usage"
      ) {
        mainHeadings = [
          // { value: "", colspan: 5, mainHeadingBorderBottom: false },
          // {
          // 	value: "Pipeline Stock",
          // 	colspan: 2,
          // 	mainHeadingBorderBottom: true
          // },
          // { value: "Updated", colspan: 2, mainHeadingBorderBottom: true },
          // { value: "", colspan: 1, mainHeadingBorderBottom: false }
        ];

        subHeadings = [
          { value: "Item Name", colspan: 1, subHeadingBorderBottom: true },
          { value: "Date", colspan: 1, subHeadingBorderBottom: true },
          { value: "Value", colspan: 1, subHeadingBorderBottom: true },
          { value: "Qty", colspan: 1, subHeadingBorderBottom: true },
          { value: "Excess", colspan: 1, subHeadingBorderBottom: true },
          { value: "UOM", colspan: 1, subHeadingBorderBottom: true },
          // { value: "Coverage Days", colspan: 1, subHeadingBorderBottom: true },
          // { value: "Date", colspan: 1, subHeadingBorderBottom: true },
          // { value: "Qty", colspan: 1, subHeadingBorderBottom: true },
          // { value: "Qty", colspan: 1, subHeadingBorderBottom: true },
          // {
          // 	value: "Updated Coverage",
          // 	colspan: 1,
          // 	subHeadingBorderBottom: true
          // },
          { value: "Usage", colspan: 1, subHeadingBorderBottom: true },
        ];
      } else if (this.params.view == "variance") {
        mainHeadings = [
          { value: "", colspan: 1, mainHeadingBorderBottom: false },
          { value: "", colspan: 1, mainHeadingBorderBottom: false },
          { value: "", colspan: 1, mainHeadingBorderBottom: false },
          { value: "", colspan: 1, mainHeadingBorderBottom: false },
          { value: "", colspan: 1, mainHeadingBorderBottom: false },
          { value: "", colspan: 1, mainHeadingBorderBottom: false },
        ];

        subHeadings = [
          { value: "Item Name", colspan: 1, subHeadingBorderBottom: true },
          { value: "Count Date", colspan: 1, subHeadingBorderBottom: true },
          {
            value: "System Stock(unit)",
            colspan: 1,
            subHeadingBorderBottom: true,
          },
          { value: "Actual Stock", colspan: 1, subHeadingBorderBottom: true },
          { value: "Variance", colspan: 1, subHeadingBorderBottom: true },
          { value: "% Variance", colspan: 1, subHeadingBorderBottom: true },
          // { value: "Qty", colspan: 1, subHeadingBorderBottom: true },
          // { value: "Qty", colspan: 1, subHeadingBorderBottom: true },
          // { value: "Updated Coverage", colspan: 1, subHeadingBorderBottom: true },
          // { value: "Usage", colspan: 1, subHeadingBorderBottom: true }
        ];
      } else {
        mainHeadings.unshift({
          value: "Item Name",
          colspan: 1,
          mainHeadingBorderBottom: false,
        }); //initially pushed item name heading
        subHeadings.unshift({
          value: "",
          colspan: 1,
          subHeadingBorderBottom: true,
        }); //initially pushed item name heading

        for (var i = 0; i < response.meta.columns.length; i++) {
          let mainHeadingObj = {
            value: response.meta.columns[i],
            colspan: 4,
            mainHeadingBorderBottom: true,
          };
          mainHeadings.push(mainHeadingObj);

          let row1 = {
            value: "Stock in Value",
            colspan: 1,
            subHeadingBorderBottom: true,
            meta: response.meta.columns[i],
          };
          let row2 = {
            value: "Stock in Units",
            colspan: 1,
            subHeadingBorderBottom: true,
            meta: response.meta.columns[i],
          };
          let row3 = {
            value: "Usage",
            colspan: 1,
            subHeadingBorderBottom: true,
            meta: response.meta.columns[i],
          };
          let row4 = {
            value: "% Usage",
            colspan: 1,
            subHeadingBorderBottom: true,
            meta: response.meta.columns[i],
          };

          subHeadings.push(row1, row2, row3, row4);
        }

        console.log("mainHeadings", mainHeadings);
        console.log("subHeadings", subHeadings);
      }

      this.tableData.mainHeadings = mainHeadings;
      this.tableData.subHeadings = subHeadings;
    },

    resetBreadCurmb() {
      this.breadCrumbs = [];
    },

    handleResetPageInfoEvent() {
      this.pageInfo.currentPage = 1;
      this.pageInfo.pageSize = 10;
      this.popupPageInfo.currentPage = 1;
      this.popupPageInfo.pageSize = 10;
    },
    handlePopupPageInfoChange(val) {
      this.popupPageInfo.currentPage = val;
      this.showTablePopup(this.article_id);
    },
    handlePageInfoSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.handlePageInfoChange(this.popupPageInfo.currentPage);
    },
    handlePageInfoChange(val) {
      this.pageInfo.currentPage = val;
      if (
        this.selectedType == "department" ||
        this.selectedType == "category" ||
        this.selectedType == "subcategory"
      ) {
        this.updateData(this.selectedType, this.selectedId, {});
      } else if (
        this.selectedType == "country" ||
        this.selectedType == "subregion" ||
        this.selectedType == "region" ||
        this.selectedType == "outlet"
      ) {
        this.changedData(this.params, this.selectedType);
      } else {
        this.changedData(this.params, this.selectedType);
      }
    },

    breadCurmbClicked(selected_bredcrumb, element) {
      this.active_breadCrumbs = selected_bredcrumb;
      for (var i in this.breadCrumbs) {
        for (var key in this.breadCrumbs[i]) {
          if (key == selected_bredcrumb) {
            // *******************Removed next clickable breadCurmb************************************
            this.breadCrumbs.splice(Number(i) + 1, this.breadCrumbs.length - 1);
          }
        }
      }
      this.updateData(element[0].type, element[0].id, element[0]);
      const routeName = this.$route.name;
    },

    defaultBreadcurmbClicked() {
      this.handleResetPageInfoEvent();
      // this.getDepartnemtList();
      this.params = {
        quickreport: "sale",
        view: "usage",
        start_date: "",
        end_date: "",
        basics: "product",
        filters: {
          outlets: [],
          subcategories: [],
          countries: [],
          regions: [],
          subregions: [],
          subcategories: [],
          departments: [],
          categories: [],
        },
      };
      const today = new Date();
      const yesterday = new Date(today);

      yesterday.setDate(yesterday.getDate() - 1);

      this.params.end_date = moment(yesterday).format("YYYY-MM-DD");
      this.params.start_date = moment(yesterday).format("YYYY-MM-DD");
      this.breadCrumbs = [];
      this.selectedType = "department";
      this.changedData(this.params, this.selectedType);
    },

    dropDownUpdate(update) {
      let start_date = moment(this.params.start_date).format("YYYY-MM-DD");
      let end_date = moment(this.params.end_date).format("YYYY-MM-DD");
      this.params = {
        article_type:
          this.params.article_type == "" ? null : this.params.article_type,
        quickreport: this.params.quickreport,
        view: this.params.view,
        start_date: start_date,
        end_date: end_date,
        basics: "product",
        filters: {
          outlets: [],
          subcategories: [],
          countries: [],
          regions: [],
          subregions: [],
        },
      };

      if (update.basics == "subregion") {
        this.params.filters.subregions = update.selected.map((e) => {
          return e.id;
        });
      } else if (update.basics == "country") {
        this.params.filters.countries = update.selected.map((e) => {
          return e.id;
        });
      } else if (update.basics == "region") {
        this.params.filters.regions = update.selected.map((e) => {
          return e.id;
        });
      } else if (update.basics == "outlet") {
        this.params.filters.outlets = update.selected.map((e) => {
          return e.id;
        });
      }
      // this.resetBreadCurmb();
      // this.handleResetPageInfoEvent();
      // this.changedData(this.params, update.basics);
    },

    categoryDropdownUpdate(update) {
      let id = update.cat_selected.map((e) => {
        return e.id;
      });
      // this.resetBreadCurmb();
      // this.handleResetPageInfoEvent();
      this.updateData(update.cat_basics, id[0], update);
    },

    // on quick report dropdown change
    changedQuickReport(reportType) {
      let filter = {};
      if (this.params.filters.outlets.length) {
        filter = this.params.filters;
      } else {
        filter = {
          outlets: [],
          subcategories: [],
          countries: [],
          regions: [],
          subregions: [],
          categories: [],
          departments: [],
        };
      }
      let start_date = moment(this.params.start_date).format("YYYY-MM-DD");
      let end_date = moment(this.params.end_date).format("YYYY-MM-DD");

      this.params = {
        quickreport: reportType,
        view: this.params.view,
        start_date: start_date,
        end_date: end_date,
        article_type:
          this.params.article_type == "" ? null : this.params.article_type,
        basics: "product",
        filters: filter,
      };

      // this.resetBreadCurmb();
      // this.handleResetPageInfoEvent();
      // this.changedData(this.params);
    },

    // on date from and to date picker change
    handleDateChange(date) {
      this.params.start_date = moment(this.params.start_date).format(
        "YYYY-MM-DD"
      );
      this.params.end_date = moment(this.params.end_date).format("YYYY-MM-DD");
      // this.resetBreadCurmb();
      // this.handleResetPageInfoEvent();
      // this.changedData(this.params);
    },

    changedData(quickReportParams, updateBasics) {
      // console.log("quickReportParams", quickReportParams, updateBasics);
      this.isTableDataLoading = true; //enabled loader
      this.inventoryList = [];
      this.selectedType = updateBasics;
      this.getSummaryData();
      InventoryService.getSubCategoryByItem(quickReportParams, this.pageInfo)
        .then((response) => {
          let inventoryList = JSON.parse(response.data).results;
          // console.log("inventoryList", inventoryList);
          this.setDatesBasedOnQuickReportType(JSON.parse(response.data));
          if (this.params.view != "stockout") {
            this.fillHeadersForTable(JSON.parse(response.data)); //fill table headers as per report type
          }
          this.isTableDataLoading = false; //disalbed loader
          this.pageInfo.count = JSON.parse(response.data).count;

          let nameMappingParams = {
            basics: this.params.basics,
            id_list: [],
          };

          if (
            this.params.quickreport != "wow" &&
            this.params.quickreport != "mom"
          ) {
            let id_list = inventoryList.map((el) => {
              return el.article_id ? el.article_id : el.basics;
            });
            nameMappingParams.id_list = id_list;

            this.nameMapping(nameMappingParams).then((res) => {
              let nameList = JSON.parse(res.data);
              // console.log("nameList", nameList);
              for (let i in inventoryList) {
                let filterd = nameList.filter(function (name) {
                  return (
                    name.id == inventoryList[i].basics ||
                    name.id == inventoryList[i].article_id
                  );
                  // if (this.params.view == "variance") {
                  // } else {
                  // 	}
                  // return name.id == inventoryList[i].article_id;
                });
                if (this.params.view == "variance") {
                  let obj = {
                    id: filterd[0].id,
                    name: filterd[0].name,
                    date: inventoryList[i].date,
                    stock_value_sum: inventoryList[i].stock_value_sum,
                    stock_units_sum: inventoryList[i].sys_stk,
                    cov_days: inventoryList[i].cov_days,
                    umo: inventoryList[i].umo,
                    re_date: inventoryList[i].re_date,
                    usage_sum: inventoryList[i].actual_stk,
                    pipeline_quantity: inventoryList[i].variance_per,
                    delta_qty: inventoryList[i].variance,
                    type: this.params.basics,
                  };
                  this.inventoryList.push(obj);
                } else if (this.params.view == "usage") {
                  let obj = {
                    id: filterd ? filterd[0].id : '',
                    name: filterd[0].name,
                    date: inventoryList[i].date,
                    stock_value_sum: inventoryList[i].stock_value,
                    stock_units_sum: inventoryList[i].stock_units,
                    excess_qty: inventoryList[i].excess_qty,
                    cov_days: inventoryList[i].coverage_days,
                    umo: inventoryList[i].umo,
                    re_date: inventoryList[i].re_date,
                    usage_sum: inventoryList[i].usage,
                    up_cov_days: inventoryList[i].updated_coverage_days,
                    pipeline_quantity: inventoryList[i].pipeline_qty,
                    delta_qty:
                      inventoryList[i].stock_units +
                      inventoryList[i].pipeline_qty,
                    type: this.params.basics,
                  };
                  this.inventoryList.push(obj);
                } else {
                  let obj = {
                    id: filterd ? filterd[0].id : '',
                    name: filterd[0].name,
                    // date: inventoryList[i].date,
                    sale_qty: inventoryList[i].sale_qty,
                    sale_value: inventoryList[i].sale_value,
                    unmet_quantity: inventoryList[i].unmet_quantity,
                    unmet_value: inventoryList[i].unmet_value,
                    forecast: inventoryList[i].forecast,
                    opening_stock: inventoryList[i].opening_stock,
                  };
                  // console.log(obj);
                  this.inventoryList.push(obj);
                }
                // this.inventoryList.push(obj);
              }
              setTimeout(() => {
                EventBus.$emit("reponseOfInventory", {
                  data: this.inventoryList,
                  name: this.params.view,
                });
              }, 100);
            });
          } else {
            let tableHeaders = [];
            let id_list = [];
            let tempInventoryList = [];

            for (var i = 0; i < inventoryList.length; i++) {
              for (var key in inventoryList[i]) {
                if (key != "columns") {
                  id_list.push(key); //separated id as a key
                  for (var key1 in inventoryList[i][key]) {
                    inventoryList[i][key][key1]["id"] = key; //stored id of item
                    inventoryList[i][key][key1]["date"] = key1; //stored date of item
                    tempInventoryList.push(inventoryList[i][key][key1]); //separated item obj
                  }
                }
              }
            }

            nameMappingParams.id_list = id_list; //pushed id in params for name mapping api

            let temp_list = [];

            this.nameMapping(nameMappingParams).then((res) => {
              let nameList = JSON.parse(res.data);

              for (let i in tempInventoryList) {
                let filterd = nameList.filter(function (name) {
                  return name.id == tempInventoryList[i].id;
                });

                let obj = {
                  id: filterd ? filterd[0].id : '',
                  name: filterd[0].name,
                  date: tempInventoryList[i].date,
                  stock_value_sum: tempInventoryList[i].stock_value_sum,
                  stock_units_sum: tempInventoryList[i].stock_units_sum,
                  usage_sum: tempInventoryList[i].usage_sum,
                  usage_per: tempInventoryList[i].usage_per,
                  type: "item",
                };
                this.inventoryList.push(obj);
                setTimeout(() => {
                  EventBus.$emit("reponseOfInventory", {
                    data: this.inventoryList,
                    name: this.params.view,
                  });
                }, 100);

                // for(var k=1; k<this.tableData.subHeadings.length; k++){
                // 	if(this.tableData.subHeadings[k].meta == tempInventoryList[i].date){
                // 		let obj = {};
                // 		this.inventoryList.push(obj);
                // 	}else{
                // 		let obj = {
                // 			id: '',
                // 			name: '',
                // 			date: '',
                // 			stock_value_sum: '',
                // 			stock_units_sum: '',
                // 			usage_sum: '',
                // 			usage_per: '',
                // 			type: "item",
                // 		}
                // 		this.inventoryList.push(obj);
                // 	}

                // 	// console.log('temp_list');
                // }
              }

              // for(var j=1; j<this.tableData.mainHeadings.length; j++){
              // console.log('sub', this.tableData.mainHeadings[j]);
              // for(var k=1; k<this.tableData.subHeadings.length; k++){
              // 	console.log('temp_list', temp_list);
              // 	// let obj = {
              // 	// 	id: 0
              // 	// };
              // 	// temp_list.push(obj);
              // }
              // }
            });
            console.log("this.inventoryList", this.inventoryList);
          }
        })
        .catch(
          function (error) {
            console.log(error);
            this.isTableDataLoading = false; //disalbed loader
          }.bind(this)
        );
    },
    showTablePopup(id) {
      this.article_id = id;
      let params = {
        filters: this.params.filters,
        article_id: id,
        // article_id: "145c79e5-216f-42e4-832a-a346659225db"
      };
      this.popupData = [];
      InventoryService.getInventoryPopupTable(params, this.popupPageInfo)
        .then((response) => {
          console.log("response", JSON.parse(response.data));
          this.popupData = JSON.parse(response.data).results;
          this.popupPageInfo.count = JSON.parse(response.data).count;
        })
        .catch((err) => {});
      let url = "/outlet/inventory-usage/coverage-days/?page=1&page_size=10";
      console.log("params", params);
    },
    updateData(type, id, data) {
      console.log("updateData", type, id, data);
      // this.isTableDataLoading = true; //enabled loader
      let newId = [];
      id == undefined ? (newId = []) : (newId = [id]);
      console.log("id", newId);
      if (type != this.selectedType) {
        this.handleResetPageInfoEvent();
      }

      // this.fillHeadersForTable(); //fill table headers as per report type

      // this.getSummaryData();
      // this.selectedId = id;

      if (type == "department") {
        // this.selectedType = "category";
        if (data.name) {
          this.storeBreadcurmb(data);
        }
        this.params.basics = "product";
        this.params.filters.departments = newId;
        this.params.filters.categories = [];
        this.params.filters.subcategories = [];
        // this.changedData(this.params, this.selectedType);
        // InventoryService.getDepartmentByCategory(id, this.pageInfo)
        // .then(response => {
        // 	let inventoryList = JSON.parse(response.data).results;
        // 	this.pageInfo.count = JSON.parse(response.data).count;

        // 	// this.fillHeadersForTable(JSON.parse(response.data));	//fill table headers as per report type

        // 	this.isTableDataLoading = false; //disalbed loader

        // 	this.inventoryList = inventoryList.map(el => {
        // 		return {
        // 			id: el.id,
        // 			name: el.name,
        // 			department: el.department,
        // 			type: "category",
        // 		}
        // 	})
        // })
        // .catch(function(error){
        // 	console.log(error);
        // 	this.isTableDataLoading = false; //disalbed loader
        // }.bind(this))
      } else if (type == "category") {
        // this.selectedType = "subcategory";

        if (data.name) {
          this.storeBreadcurmb(data);
        }
        this.params.basics = "product";
        this.params.filters.departments = [];
        this.params.filters.subcategories = [];
        this.params.filters.categories = newId;
        // this.changedData(this.params, this.selectedType);
        // InventoryService.getCategoryBySubCategory(id, this.pageInfo)
        // .then(response => {
        // 	let inventoryList = JSON.parse(response.data).results;
        // 	this.pageInfo.count = JSON.parse(response.data).count;

        // 	// this.fillHeadersForTable(JSON.parse(response.data));	//fill table headers as per report type

        // 	this.isTableDataLoading = false; //disalbed loader

        // 	this.inventoryList = inventoryList.map(el => {
        // 		return {
        // 			id: el.id,
        // 			name: el.name,
        // 			department: el.department,
        // 			type: "subcategory",
        // 		}
        // 	})
        // })
        // .catch(function(error){
        // 	console.log(error);
        // 	this.isTableDataLoading = false; //disalbed loader
        // }.bind(this))
      } else if (type == "subcategory") {
        this.selectedType = "product";
        if (data.name) {
          this.storeBreadcurmb(data);
        }
        this.params.filters.categories = [];
        this.params.filters.departments = [];
        this.params.filters.subcategories = newId;
        this.params.basics = this.selectedType;
        // this.changedData(this.params, this.selectedType);
        // this.inventoryList = [];
      } else if (type == "product") {
        this.selectedType = "product";
        if (data.name) {
          this.storeBreadcurmb(data);
        }
        this.params.filters.categories = [];
        this.params.filters.departments = [];
        this.params.filters.subcategories = [];
        this.params.filters.articles = newId;
        this.params.filters.ar = [];
        this.params.basics = this.selectedType;
        // this.changedData(this.params, this.selectedType);
      } else {
        this.isTableDataLoading = false; //disalbed loader
      }
    },

    nameMapping(params) {
      return InventoryService.nameMapping(params);
    },

    lookup(name, breadCrumbs) {
      var regex = /^\d{4}-\d{2}-\d{2}$/;
      for (var i in breadCrumbs) {
        for (var key in breadCrumbs[i]) if (key === name) return true;
      }
      return false;
    },

    storeBreadcurmb(element) {
      var temp = [];
      temp.push(element);
      if (this.breadCrumbs.length) {
        if (!this.lookup(element.name, this.breadCrumbs)) {
          this.breadCrumbs.push({
            [element.name]: temp,
          });
        }
      } else {
        this.breadCrumbs.push({
          [element.name]: temp,
        });
      }
    },

    disabledDueDate(time) {
      if (this.params.quickreport == "week") {
        var mondays = this.getAllMondayFromYear(time);
        return !mondays.includes(moment(time).format("YYYY-MM-DD"));
      } else if (this.params.quickreport == "month") {
        var first_date = new Date(time),
          year = first_date.getYear(),
          mondays = [];
        // first_date.setDate(1);
        var now = new Date();
        var next_month_firstDate = new Date(
          now.getFullYear(),
          now.getMonth() + 1,
          1
        );
        if (next_month_firstDate > first_date) {
          if (new Date(1).getDate() != time.getDate()) {
            return time.getTime();
          }
        } else {
          return time.getTime();
        }
      } else {
        return time.getTime() > new Date().getTime();
      }
    },

    getAllMondayFromYear(time) {
      var d = new Date(time),
        year = d.getYear(),
        mondays = [];
      if (d < new Date()) {
        d.setDate(1);
        // Get the first Monday in the month
        while (d.getDay() !== 1) {
          d.setDate(d.getDate() + 1);
        }

        // Get all the other Mondays in the month
        while (d.getYear() === year) {
          var pushDate = new Date(d.getTime());
          mondays.push(moment(pushDate).format("YYYY-MM-DD"));
          d.setDate(d.getDate() + 7);
        }
      }
      return mondays;
    },

    setDatesBasedOnQuickReportType(responseData) {
      if (
        responseData.meta.hasOwnProperty("start_date") &&
        responseData.meta.start_date != "" &&
        responseData.meta.hasOwnProperty("end_date") &&
        responseData.meta.end_date != ""
      ) {
        // if(this.quickReports != 'mom'){
        this.params.start_date = moment(responseData.meta.start_date).format(
          "YYYY-MM-DD"
        );
        this.params.end_date = moment(responseData.meta.end_date).format(
          "YYYY-MM-DD"
        );
      }
    },

    locationDropdownUpdate() {},

    // rowButtonClicked(element, indexOfRow) {
    // 	if (element.isClickedAlready) {
    // 		this.tempTD.data.rows.splice(
    // 			indexOfRow + 1,
    // 			this.outlet2Categories.data.rows.length
    // 		);
    // 		element.isClickedAlready = false;
    // 	} else {
    // 		this.tempTD.data.rows.splice(
    // 			indexOfRow + 1,
    // 			0,
    // 			...this.outlet2Categories.data.rows
    // 		);
    // 		element.isClickedAlready = true;
    // 	}
    // 	console.log("this.tempTD.data.rows", this.tempTD.data.rows);
    // 	// if (element.isShowGraph) {
    // 	// 	this.showGraphForPartRow(indexOfRow);
    // 	// }
    // 	// EventBus.$emit("buttonClickedEvent", element);
    // }
  },
};
</script>

<style lang="scss" scoped>
@import "./InventoryDashboard.scss";
.tableHeader {
  background: #f2f2f2;
  text-transform: uppercase;
  color: #707070 !important;
  th {
    padding: 12px !important;
    font: Bold 13px/13px "Avenir", Helvetica, Arial, sans-serif !important;
    letter-spacing: 0px;
    color: #707070;
    border-bottom: 2px solid #999;
  }
}
.toggle-btn {
  background-color: #e29d5a;
  color: #fff;
  // border-color: #606060;
}
</style>
<style>
.el-popover .el-table th > .cell {
  text-align: center !important;
}
.el-popover .el-table td > .cell {
  text-align: center !important;
}
.el-pager li:not(.disabled).active {
  background-color: #f7ba89 !important;
}
</style>
